import { SubscriptionScopeKeysByType } from './enum/SubscriptionScopeKeysByType';
import { CommonUrl } from '../utils/CommonUrl';
import { getAppRouteData } from '../utils/getAppRouteData';
import { SubscriptionResult } from './SubscriptionResult';
import { SubscriptionResultRecurring } from './SubscriptionResultRecurring';
// import { getAuth } from '../utils/getAuth';
// import { SubscriptionScopeKey } from './enum/SubscriptionScopeKey';

export const SubscriptionCheck = {
    withKeys(subscriptionKeys = []) {
        return new SubscriptionResult(subscriptionKeys);
    },

    withTransactionType(type) {
        const subscriptionKeys = SubscriptionScopeKeysByType[type] || [];
        return new SubscriptionResult(subscriptionKeys);
    },

    withRecurring(type, isRecurring) {
        const checkByType = SubscriptionCheck.withTransactionType(type);
        const checkRecurring = isRecurring ?
            SubscriptionCheck.withUrl(CommonUrl.instruction) :
            new SubscriptionResult();

        return new SubscriptionResultRecurring(checkByType.keys, checkRecurring.keys);
    },

    withUrl(url) {
        // Getting a match
        const route = getAppRouteData(url);
        const subscriptionKeys = route?.subscription || [];
        const subscriptionCheckMethod = route?.subscriptionCheckMethod || null; // 'OR' or 'AND'
        return new SubscriptionResult(subscriptionKeys, subscriptionCheckMethod);
    },

    withCurrentRoute() {
        if (!window || !window.location.pathname)
            return new SubscriptionResult();

        // Getting a match
        const route = getAppRouteData(window.location.pathname);
        const subscriptionKeys = route?.subscription || [];
        const subscriptionCheckMethod = route?.subscriptionCheckMethod || null; // 'OR' or 'AND'

        return new SubscriptionResult(subscriptionKeys, subscriptionCheckMethod);
    },

    // returns: STRING 'BASIC' or 'ADVANCED' (in SubscriptionPermissionType)
    // getPermissionType() {
    //     const { subscription } = getAuth();
    //     const { scopes = {} } = subscription || {};
    //     return scopes[SubscriptionScopeKey.permission];
    // },
};
